import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { MonitoringSiteItem } from './MonitoringSiteItem'

interface RandomSitesSectionProps {
  randomSites: Array<{
    properties: {
      id?: string | number
      clientId?: string
      name: string
      isRandomSite?: boolean
      randomizeCounter?: number
    }
    geometry: {
      coordinates: [number, number]
    }
  }>
  strataColor: string
  wasSaved: boolean
  reRandomize?: boolean
  onNameChange: (index: number, newName: string) => void
  onReRandomize: (index: number) => void
}

export const RandomSitesSection = ({
  randomSites,
  strataColor,
  wasSaved,
  reRandomize,
  onNameChange,
  onReRandomize,
}: RandomSitesSectionProps) => {
  if (!randomSites || randomSites.length === 0) {
    return null
  }

  return (
    <Box sx={{ py: 2 }}>
      {/* Header */}
      <Stack
        alignItems="center"
        direction="row"
        spacing={2}
        sx={{ p: 2, mb: 1, justifyContent: 'space-between' }}
      >
        <Stack alignItems="center" direction="row" spacing={2}>
          {/* Dot circular para sitios aleatorios */}
          <Box
            sx={{
              backgroundColor: strataColor,
              filter: 'saturate(2.5)',
              borderRadius: '50%',
              width: 18,
              height: 18,
              display: 'inline-block',
              flexShrink: 0,
            }}
          />
          <Typography fontWeight={600} variant="accordionTitle">
            Sitios Aleatorios ({randomSites.length})
          </Typography>
        </Stack>
        {reRandomize && !wasSaved && (
          <Typography fontWeight={600} variant="body2">
            Re-aleatorizar
          </Typography>
        )}
      </Stack>

      {/* Lista de sitios */}
      {randomSites.map((monitoringSite, index) => (
        <MonitoringSiteItem
          key={
            monitoringSite.properties.id ||
            monitoringSite.properties.clientId ||
            monitoringSite.properties.name
          }
          isRandomSite
          monitoringSite={monitoringSite}
          reRandomize={reRandomize}
          wasSaved={wasSaved}
          onNameChange={newName => onNameChange(index, newName)}
          onReRandomize={() => onReRandomize(index)}
        />
      ))}
    </Box>
  )
}
